import { Inject, Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigService } from './config.service';
// import { BasicResponse, UsersAPI } from '../model/basic-response';
import { ServicePoint, ServicePointAccess } from '../model/servicePoint';
// import { GidAccessControl } from '../..';

export interface ServicePointAPI {
  items: ServicePoint[];
  total_count: number;
}

@Injectable({
  providedIn: 'root'
})
export class ServicePointService {
  private URL;
  headers: HttpHeaders;

  constructor( @Inject(ConfigService) private config, private httpClient: HttpClient) {
    this.URL = config.REST_SERVER_HOST + config.REST_SERVER_url.find(restUrl => restUrl.api === 'PADM').url;
    this.headers = new HttpHeaders().set('DoNotIntercept', 'true');
  }

  private static handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    // return throwError('Something bad happened; please try again later.');
    return throwError(error);
  }

  getServicePoints(pageIndex: number, pageSize: number, sortActive: string, sort: string): Observable<ServicePointAPI> {
    const headers = this.headers;
    if ((sortActive === '') || (sort === '')) {
      sortActive = '0';
      sort = 'asc';
    }
    return this.httpClient.get<ServicePointAPI>(
      `${this.URL}/servicepoint/sps/${pageIndex}/${pageSize}/${sortActive}/${sort}`, { headers })
      .pipe(
        catchError(ServicePointService.handleError)
    );

  }

  getServicePointsSelect(searchVal: string): Observable<ServicePoint[]> {
    const headers = this.headers;
    if (searchVal === '') {
      searchVal = '';
    }
    // See C001 - 2026-03-26 - HE
    // // return this.httpClient.get<ServicePoint[]>(
    // //   `${this.URL}/servicepoint/sps/searchlist/${searchVal}`, { headers })
    // //   .pipe(
    // //     catchError(ServicePointService.handleError)
    // //   );
    return this.httpClient
      .get<unknown>(`${this.URL}/servicepoint/sps/searchlist/${searchVal}`, {
        headers,
      })
      .pipe(
        map((body) => ServicePointService.normalizeServicePointArray(body)),
        catchError(ServicePointService.handleError)
      );
  }

  getServicePointGroup(spsId: number): Observable<ServicePoint[]> {
    const headers = this.headers;
    // See C001 - 2026-03-26 - HE
    // // return this.httpClient.get<ServicePoint[]>(
    // //   `${this.URL}/servicepoint/sps/grouplist/${spsId}`, { headers })
    // //   .pipe(
    // //     catchError(ServicePointService.handleError)
    // //   );
    return this.httpClient
      .get<unknown>(`${this.URL}/servicepoint/sps/grouplist/${spsId}`, {
        headers,
      })
      .pipe(
        map((body) => ServicePointService.normalizeServicePointArray(body)),
        catchError(ServicePointService.handleError)
      );
  }

  /**
   * PADM searchlist/grouplist may return id/spiId as strings and globalID as number.
   * Normalize to ServicePoint (id number, globalID string) for ng-select, mat-select, and saves.
   */
  private static normalizeServicePointFromApi(raw: unknown): ServicePoint {
    if (raw == null || typeof raw !== 'object') {
      return { id: 0, globalID: '', servicePointName: '' };
    }
    const r = raw as Record<string, unknown>;
    const idNum = Number(r['id']);
    const spiRaw = r['spiId'];
    const gid = r['globalID'];
    return {
      id: Number.isFinite(idNum) ? idNum : 0,
      globalID: gid == null ? '' : String(gid),
      servicePointName:
        r['servicePointName'] == null ? '' : String(r['servicePointName']),
      spiId:
        spiRaw == null || spiRaw === ''
          ? undefined
          : Number(spiRaw),
      defaultGID:
        typeof r['defaultGID'] === 'boolean' ? r['defaultGID'] : undefined,
    };
  }

  private static normalizeServicePointArray(payload: unknown): ServicePoint[] {
    if (!Array.isArray(payload)) {
      return [];
    }
    return payload.map((x) => ServicePointService.normalizeServicePointFromApi(x));
  }
}

// ========================================
// CHANGE LOG
// ========================================
// C001: Normalize PADM searchlist/grouplist JSON to ServicePoint shape. What changed: getServicePointsSelect() and getServicePointGroup() now pipe map(normalizeServicePointArray) so each item has id as number (from string or number), globalID as string (from number or string), servicePointName as string, optional spiId as number. Added private normalizeServicePointFromApi and normalizeServicePointArray. Previous behavior: Raw API body was typed as ServicePoint[] but backend returned id/spiId as strings and globalID as numbers (e.g. padmdev.pythius.co.za searchlist). New behavior: Consumers (gid-select, GID access compareWith, save payloads) see consistent types. Reason: Match actual API response and libs/services ServicePoint interface. Impact: Search and group lists work reliably across environments with loose JSON typing. - 2026-03-26 - HE
